import { request } from "@/utils/request";

let pendingTaskCenterRequest = null;

// 任务中心接口，对接文档：
// docs/任务中心接口-前端对接文档-20260917.md
export function getTaskCenter() {
  if (!pendingTaskCenterRequest) {
    pendingTaskCenterRequest = request({
      url: "v2/tasks",
      method: "get",
    }).finally(() => {
      pendingTaskCenterRequest = null;
    });
  }

  return pendingTaskCenterRequest;
}
